import { requestService } from 'shared/utils/services/requestService';

// Gets a non-fungible product's data such as used, new_with_defect, etc
export const fetchProductIdData = (productId: string, countryCode: string) =>
  requestService({
    url: `/web-api/v1/products/${productId}?countryCode=${countryCode}`,
    method: 'GET',
  });
